import { Component, HostListener, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-route-planner',
  templateUrl: './route-planner.component.html',
  styleUrls: ['./route-planner.component.css']
})
export class RoutePlannerComponent implements OnInit {
  @Input() routeData: any;
  @Input() drivers;
  @Input() preData;
  @Input() preServiceAreas;
  @Input() trips;
  latitude: number;
  longitude: number;
  selectedDriverDetail;
  selectedDriver = '';
  preTrips: any = {};
  filteredTrips = [];
  zoom: number = 12;
  search;
  selectedTripId;

  /** Draggable bottom panel height in px */
  tableHeight: number = 0;
  private _isDragging = false;
  private _dragStartY: number = 0;
  private _dragStartHeight: number = 0;
  private readonly MIN_TABLE_HEIGHT = 60;
  private readonly MAX_TABLE_HEIGHT_RATIO = 0.85;

  constructor() { }

  ngOnInit() {
    // Table Height
    this.tableHeight = window.innerHeight * 0.6;

    console.log("routeData: ", this.routeData)
    console.log("trips: ",this.trips)

    this.preTrips = this.trips.reduce((obj: any, item: any) => {
      obj[item._id] = item;
      return obj;
    }, {});

    if (this.routeData && this.routeData.compatible) {
      const driverKeys = Object.keys(this.routeData.compatible);
      if (driverKeys.length > 0 && !this.selectedDriver) {
        this.selectedDriver = driverKeys[0];
        this.onSelectDriver();
      }
    }

  }

  onSelectDriver() {
    this.filteredTrips = [];
    this.selectedDriverDetail = [];
    if (this.routeData.compatible[this.selectedDriver]) {
      this.filteredTrips = this.routeData.compatible[this.selectedDriver].stops;
      this.selectedDriverDetail = this.routeData.compatible[this.selectedDriver].driver;
    }
  }

  getMarkeBall(isPickup) {

    let icon = isPickup === 'pickup' ? 'assets/images/map/origin_circle.png' : 'assets/images/map/destination_circle.png'
    return icon;
  }

  startDrag(event: MouseEvent) {
    event.preventDefault();
    this._isDragging = true;
    this._dragStartY = event.clientY;
    this._dragStartHeight = this.tableHeight;
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this._isDragging) return;
    const delta = this._dragStartY - event.clientY; // drag up = increase height
    const maxHeight = window.innerHeight * this.MAX_TABLE_HEIGHT_RATIO;
    this.tableHeight = Math.min(
      maxHeight,
      Math.max(this.MIN_TABLE_HEIGHT, this._dragStartHeight + delta)
    );
  }

  @HostListener('document:mouseup')
  onMouseUp() {
    this._isDragging = false;
  }

}
